import { render, staticRenderFns } from "./Sustainability.vue?vue&type=template&id=6f9c9abc&"
import script from "./Sustainability.vue?vue&type=script&lang=js&"
export * from "./Sustainability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports